export default __webpack_public_path__ + "static/media/icon1.868894e9.png";